// import "babel-polyfill";
// import "raf/polyfill";
// import "es5-shim";
// import "es5-shim/es5-sham";
// import "console-polyfill";
// if (!global._babelPolyfill) {
//   require("babel-polyfill");
// }
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "mobx-react";
import Routes from "./Routes";
import stores from "./store";


// 创建追踪器
window.xmLog("pv.create", {});

ReactDOM.render(
  <Provider {...stores}>
    <Router basename="activities">
      <Routes />
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js